// extracted by mini-css-extract-plugin
module.exports = {"PromotionalCarousel__carousel":"styles_PromotionalCarousel__carousel__4LoJf"};